module.exports = __webpack_public_path__ + "img/Atom_code_accueil.c00c6df7.png";